import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { MortgageApplicationContext } from '../../models/mortgage-application-context.model';
import { MortgageApplicationFormService } from '../../services/mortgage-application-form.service';
import { BaseMortgageApplicationComponent } from '../base-mortgage-application.component';
import { MortgageApplicationStore } from './../../services/mortgage-application-store';

@Component({
  selector: 'boi-your-mortgage',
  templateUrl: './your-mortgage.page.html',
  styleUrls: ['./your-mortgage.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YourMortgagePage extends BaseMortgageApplicationComponent {
  public isFeeUpToDate = true;
  public shouldHideIsRecommendedCode: boolean;

  constructor(
    protected mortgageApplicationStore: MortgageApplicationStore,
    public changeDetectorRef: ChangeDetectorRef,
    public readonly mortgageApplicationFormService: MortgageApplicationFormService
  ) {
    super(mortgageApplicationStore);
    this.shouldHideIsRecommendedCode =
      this.mortgageApplicationFormService.getCurrentContext() === MortgageApplicationContext.Direct;
  }
}
